module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada_footer-b4aee1783bea3ace18b9bdf066a2406e.svg";